import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BackIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>;

const TestDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[var(--bg-main)] text-[var(--text-main)] p-8 flex justify-center items-start pt-20 transition-colors duration-300">
            <div className="max-w-md w-full">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 text-slate-400 hover:text-white mb-8 transition-colors font-medium hover:bg-slate-800 px-4 py-2 rounded-xl"
                >
                    <BackIcon className="w-5 h-5" /> Back to List
                </button>
                <div className="p-10 bg-slate-900 border border-slate-800 rounded-3xl text-center shadow-2xl relative overflow-hidden">
                    <div className="absolute top-0 w-full h-32 bg-gradient-to-b from-indigo-900/20 to-transparent pointer-events-none" />
                    <h1 className="text-4xl font-black text-indigo-400 mb-4 relative z-10">Item {id}</h1>
                    <p className="text-slate-300 text-lg mb-6 relative z-10">This is the details view for Item {id}.</p>
                    <div className="h-px bg-slate-800 w-full my-6 relative z-10" />
                    <p className="text-sm text-slate-500 relative z-10">Click "Back to List" or use the browser back button to verify scroll restoration works without Material UI wrappers.</p>
                </div>
            </div>
        </div>
    );
};

export default TestDetailPage;
